// Tela Jobs: um gatilho e uma instrução, que cita a Skill.
const jobs = {
  title: "Jobs",
  description: "Skills que rodam sozinhas, por horário ou quando um webhook é chamado.",
  newJob: "Novo job",
  empty: {
    title: "Nenhum job ainda",
    description: "Um job roda uma Skill sozinho: todo dia útil às 9:00, ou sempre que um sistema chamar o webhook dele.",
    adminHint: "Crie um aqui, ou peça à IA no chat.",
  },
  loadFailed: "Não foi possível carregar os jobs.",
  noWorkspace: "Selecione um workspace para ver os jobs.",
  tabs: {
    jobs: "Jobs",
    runs: "Execuções",
  },
  // Job proposto a partir de uma Skill
  proposal: {
    title: "Montando o job a partir da Skill",
    stages: {
      loading: "Carregando o formulário",
      filling: "Preenchendo o job a partir da Skill",
      finishing: "Fazendo os últimos ajustes",
    },
    reason: "Proposta da IA: {{reason}} Revise antes de salvar.",
    ready: "a proposta foi montada a partir da Skill.",
    failed: "Não foi possível montar a proposta. A Skill já está citada na instrução; complete o resto à mão.",
  },
  // Referências na instrução com @
  mentions: {
    skill: "Skill",
    mind: "Mind",
    workspace: "Workspace",
    tool: "Tool",
    // O que cada tipo traz, no primeiro passo da lista
    kindHint: {
      skill: "Skills instaladas",
      mind: "Blocos da Mind",
      workspace: "Nome, Soul, site e membros",
      tool: "Integrações instaladas",
    },
    workspaceFields: {
      name: "Nome do workspace",
      description: "Soul (descrição)",
      website: "Site",
      members: "Membros",
    },
    empty: "Nada encontrado.",
    loading: "Carregando…",
    unknown: "Não encontrado neste workspace: o job não será salvo com esta referência.",
  },
  // Histórico geral das execuções
  runs: {
    searchPlaceholder: "Buscar no resumo ou pelo nome do job",
    filter: {
      all: "Todas",
      running: "Em andamento",
      completed: "Concluídas",
      failed: "Com falha",
      job: "Job",
    },
    period: {
      "24h": "Últimas 24 horas",
      "7d": "Últimos 7 dias",
      "30d": "Últimos 30 dias",
      all: "Todo o período",
    },
    columns: {
      job: "Job",
      status: "Status",
      trigger: "Disparo",
      started: "Início",
      duration: "Duração",
      summary: "Resumo",
      writes: "Alterações",
      pending: "Pendências",
    },
    status: {
      running: "Em andamento",
      waiting: "Aguardando",
      completed: "Concluída",
      failed: "Falhou",
      cancelled: "Cancelada",
    },
    trigger: {
      schedule: "Horário",
      webhook: "Webhook",
      manual: "Manual",
    },
    // Filtro pelo modo como a execução começou
    triggerFilter: {
      all: "Todos os disparos",
      schedule: "Por horário",
      webhook: "Por webhook",
      manual: "Manuais",
    },
    empty: {
      title: "Nenhuma execução ainda",
      description: "Quando um job publicado disparar, cada execução aparece aqui, com o resumo do que o agente fez.",
    },
    noResults: "Nenhuma execução com esses filtros.",
    loadFailed: "Não foi possível carregar as execuções.",
    loadMore: "Carregar mais",
    loadingRun: "Carregando a execução…",
    runLoadFailed: "Não foi possível carregar esta execução.",
    jobSettings: "Configurações do job",
    actionsTitle: "Ações",
    actionFailed: "falhou",
    usage: "{{calls}} chamadas ao modelo · {{tokens}} tokens",
  },
  filter: {
    searchPlaceholder: "Buscar por nome, instrução ou Skill",
    clearSearch: "Limpar busca",
    all: "Todos",
    published: "Publicados",
    draft: "Rascunhos",
    trigger: "Gatilho",
    schedule: "Por horário",
    webhook: "Webhook",
    clear: "Limpar filtros",
    noResults: "Nenhum job com esses filtros.",
  },
  columns: {
    name: "Nome",
    instruction: "Instrução",
    trigger: "Gatilho",
    status: "Status",
    lastRun: "Última execução",
    actions: "Ações",
  },
  status: {
    draft: "Rascunho",
    published: "Publicado",
  },
  lastRun: {
    never: "Nunca rodou",
    openHistory: "Ver as execuções deste job",
  },
  actions: {
    test: "Executar agora",
    publish: "Publicar",
    edit: "Configurações do job",
    history: "Histórico",
    delete: "Excluir",
  },
  // Alterações do rascunho que ainda não estão em vigor
  pending: {
    state: {
      not_run: "Alterações não executadas",
      running: "Executando as alterações…",
      completed: "Alterações executadas com sucesso",
      failed: "A execução das alterações falhou",
    },
    titlePublished: "Alterações não publicadas",
    titleDraft: "Ainda não publicado",
    neverPublished: "Este job nunca foi publicado: nada roda sozinho até você publicar.",
    changed: "O que mudou",
    fields: {
      instruction: "Instrução",
      trigger: "Gatilho",
      timeout_minutes: "Tempo máximo por execução",
      max_writes: "Limite de alterações por execução",
    },
    live: "Em vigor",
    draft: "Rascunho",
    lastManualRun: "Execução manual desta versão",
    notRunYet: "Esta versão ainda não foi executada.",
    viewResult: "Ver resultado",
  },
  delete: {
    confirmTitle: "Excluir {{name}}?",
    confirmDescription: "O job para de rodar e o histórico de execuções dele é apagado junto. Não tem como desfazer.",
    confirmDescriptionWebhook:
      "O job para de rodar, o histórico de execuções dele é apagado junto e o endereço do webhook deixa de aceitar chamadas. Não tem como desfazer.",
    confirm: "Excluir",
    deleting: "Excluindo…",
    cancel: "Cancelar",
    success: "{{name}} foi excluído",
  },
  form: {
    createTitle: "Novo job",
    editTitle: "Configurações do job",
    description: "O que o agente faz e quando roda.",
    name: "Nome",
    namePlaceholder: "Status semanal do time",
    descriptionLabel: "Descrição",
    descriptionPlaceholder: "O que este job faz (opcional)",
    instruction: "Instrução",
    instructionPlaceholder:
      "Siga @skill:status-report: resuma o que avançou em @tool:[Azure DevOps] desde a última execução, compare com as metas de @mind:goals e mande o resumo para @workspace:members.",
    instructionHelp: "Digite @ para citar uma Skill, um bloco da Mind, um dado do workspace ou uma Tool.",
    trigger: "Gatilho",
    triggerSchedule: "Por horário",
    triggerWebhook: "Quando um webhook for chamado",
    webhookHelp: "O job roda quando um sistema externo chama o endereço dele. O que ele envia chega ao agente como material de apoio.",
    frequency: "Frequência",
    presets: {
      everyMinutes: "A cada alguns minutos",
      everyHours: "A cada algumas horas",
      daily: "Todo dia",
      weekdays: "Dias úteis",
      weekly: "Semanal",
      monthly: "Mensal",
      custom: "Avançado (cron)",
    },
    time: "Horário",
    every: "A cada",
    minutes: "{{count}} minutos",
    hours_one: "{{count}} hora",
    hours_other: "{{count}} horas",
    days: "Dias da semana",
    monthDay: "Dia do mês",
    lastDay: "Último dia do mês",
    window: "Só dentro de uma janela de horário",
    windowFrom: "Das",
    windowTo: "Até",
    weekdaysOnly: "Só em dias úteis",
    cron: "Expressão cron",
    cronHelp: "Cinco campos: minuto hora dia-do-mês mês dia-da-semana. 0 ou 7 = domingo, L = último dia do mês. Exemplo: 0 9 * * 1-5",
    cronFields: {
      minute: "minuto",
      hour: "hora",
      day: "dia do mês",
      month: "mês",
      weekday: "dia da semana",
    },
    invalidCronField: "Valor inválido no campo {{field}}",
    invalidWindow: "O fim precisa ser depois do início",
    pickDays: "Escolha pelo menos um dia",
    timezone: "Fuso horário",
    timezoneSearch: "Buscar fuso horário",
    timezoneEmpty: "Nenhum fuso encontrado",
    nextRuns: "Próximas execuções",
    noPreview: "Corrija o agendamento para ver quando ele roda",
    advanced: "Limites",
    timeout: "Tempo máximo por execução (minutos)",
    timeoutHelp: "De 1 a 60. Padrão 15.",
    maxWrites: "Alterações em sistemas externos por execução",
    maxWritesHelp: "De 0 a 200. Padrão 20.",
    cancel: "Cancelar",
    test: "Executar agora",
    publish: "Publicar",
    publishing: "Publicando…",
    required: "Obrigatório",
    invalidTime: "Use HH:MM",
    invalidCron: "Use cinco campos: minuto hora dia-do-mês mês dia-da-semana",
  },
  saved: {
    created: "Job salvo como rascunho",
    updated: "Job atualizado",
    nextStep: "Execute agora para conferir o resultado e depois publique para ele começar a rodar.",
  },
  webhook: {
    url: "Endereço do webhook",
    authType: "Autenticação",
    basic: "Usuário e senha (Basic)",
    bearer: "Token (Bearer)",
    username: "Usuário",
    password: "Senha",
    token: "Token",
    tokenPlaceholder: "Deixe em branco para o Prodgy gerar um",
    show: "Mostrar",
    hide: "Esconder",
    copy: "Copiar",
    copied: "Copiado",
    loading: "Carregando o webhook…",
    handoffTitle: "Webhook pronto",
    handoffDescription: "Configure estes dados no sistema que vai chamar o webhook. O job só começa a receber chamadas depois de publicado; você pode ver estes dados de novo nas Configurações do job.",
    basicHint: "Quem chama envia o cabeçalho Authorization: Basic, com o usuário e a senha abaixo.",
    bearerHint: "Quem chama envia o cabeçalho Authorization: Bearer, com o token abaixo.",
    done: "Pronto",
  },
  test: {
    title: "Execução manual: {{name}}",
    description: "Executa o rascunho uma vez, agora, sem publicar. O que o agente fizer nos sistemas é real e fica no histórico.",
    stages: {
      queued: "Na fila",
      working: "Agente trabalhando",
      result: "Resultado",
      completed: "Concluído",
      failed: "Falhou",
    },
    showMore: "Ver mais",
    showLess: "Ver menos",
    pendingCount: "{{count}} pendentes",
    summary: "Resumo",
    pending: "Ficou pendente",
    actions: "{{count}} ações",
    writes: "{{count}} alterações em sistemas externos",
    noReport: "O agente não devolveu relatório.",
    close: "Fechar",
    publish: "Publicar",
  },
  publish: {
    confirmTitle: "Publicar {{name}}?",
    confirmDescription: "A partir de agora o gatilho dispara sozinho. Você ainda pode editar o rascunho e publicar de novo depois.",
    recommendNotRun: "Esta versão ainda não foi executada. Recomendamos executar agora e conferir o resultado antes de publicar.",
    recommendFailed: "A última execução desta versão falhou. Recomendamos corrigir e executar de novo antes de publicar.",
    confirm: "Publicar",
    publishing: "Publicando…",
    cancel: "Cancelar",
    success: "Job publicado",
  },
  settings: {
    jobNotice: "Este é um job: um gatilho e um passo do agente, editado na tela Jobs. Acrescentar passos aqui o transforma em fluxo, e ele passa para a tela Flows.",
  },
};

export default jobs;
